import { ReferenceField, useRecordContext } from 'react-admin'

import CurrentBookingField from './CurrentBookingField'
import LastLockOperationField from './LastLockOperationField'

const VehicleUsageSection = () => {
  const { booking_id } = useRecordContext()

  return (
    <>
      <CurrentBookingField />
      {/*TODO: Consider adding maintenance too */}
      <ReferenceField reference="events" source="event_id" link={false}>
        <LastLockOperationField bookingId={booking_id} />
      </ReferenceField>
    </>
  )
}

export default VehicleUsageSection
